module.exports = __webpack_public_path__ + "static/media/mazaZoleWon_25_50.fcec794d.png";